<app-checkout-header></app-checkout-header>
<div class="mx-auto max-w-screen-lg px-4 py-8 md:px-0 md:py-2">
    <ng-content></ng-content>
</div>
